<template>
  <modal name="extraordinary-sitting-modal"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Արտահերթ նիստ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('extraordinary-sitting-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <h4 class="mt-0 header-title ml-4">Ում նախաձեռնությամբ է հրավիրված նիստ</h4>
      <div class="col-lg-10 d-flex flex-column ml-4">
        <div class="radio radio-info form-check-inline">
          <input type="radio" id="inlineRadio1" value="option1" name="radioInline" checked="">
          <label for="inlineRadio1">Պատվիրատուի ղեկավարի</label>
        </div>
        <div class="radio form-check-inline">
          <input type="radio" id="inlineRadio2" value="option2" name="radioInline">
          <label for="inlineRadio2">Գնահատող հանձնաժողովի</label>
        </div>
      </div>
      <div class="card-body">
        <div class="mt-3">
          <label class="mb-2">Նիստի օրակարգ</label>
          <textarea  class="form-control" maxlength="225" rows="3" placeholder=""></textarea>
        </div>
        <div class="mt-3">
          <label class="mb-2">Նիստի բովանդակություն</label>
          <textarea class="form-control" maxlength="225" rows="3"></textarea>
        </div>
        <div class="mt-3">
          <label class="mb-2">Հաջորդ նիստի օր ու ժամ</label>
          <input class="form-control" type="datetime-local" value="2011-08-19T13:45:00" id="example-datetime-local-input">
        </div>
      </div>
      <div class="card-footer d-flex justify-content-lg-end mb-2 mt-2">
        <button type="button" class="btn btn-secondary apply p-2">
          Հաստատել
        </button>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="$modal.hide('extraordinary-sitting-modal')" type="button" class="btn btn-sm btn-primary">
        Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'ExtraordinarySitting',
  }
</script>

<style scoped>

</style>
